import './index.css';
import ConfirmationPage from './routes/ConfirmationPage';
import EnvironmentVariables from './shared/environmentVariables';
import ErrorPage from './routes/ErrorPage';
import MobileRegistrationPage, { loader as mobileRegistrationLoader } from './routes/MobileRegistrationPage';
import PricingPage, { loader as pricingLoader } from './routes/PricingPage';
import React from 'react';
import ReactDOM from 'react-dom/client';
import RegistrationPage, { loader as registrationLoader } from './routes/RegistrationPage';
import reportWebVitals from './reportWebVitals';
import theme from './shared/theme';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from '@mui/material/styles';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';

const router = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to="subscription/pricing" replace />,
    errorElement: <ErrorPage />,
  },
  {
    path: "signup",
    element: <MobileRegistrationPage />,
    loader: mobileRegistrationLoader,
    errorElement: <ErrorPage />,
  },
  {
    path: "subscription/signup-complete",
    element: <ConfirmationPage />,
    errorElement: <ErrorPage />
  },
  {
    path: "subscription/pricing",
    element: <PricingPage />,
    loader: pricingLoader,
    errorElement: <ErrorPage />
  },
  {
    path: "registration",
    element: <RegistrationPage />,
    loader: registrationLoader,
    errorElement: <ErrorPage />
  },
  {
    path: "error",
    element: <ErrorPage />
  }
]);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Helmet>
        {EnvironmentVariables.ENVIRONMENT !== 'Production' && <meta name="robots" content="none" />}
      </Helmet>
      <ThemeProvider theme={theme}>
        <RouterProvider router={router} />
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
